export class CurrencyType
{
    CurrencyCode!: string | null;
    CurrencyName!: string;
    ExchangeRate ?: Number;
    DivisionRate!: Number;
    IsActive!: boolean;
    ModuleName!: string;   
}